import('./bootstrap.js');